'use strict';

{
  /* --- FV アニメーション --- */
  const fvEls = document.querySelectorAll('.js-sG-fvEl');

  window.addEventListener('DOMContentLoaded', () => {
    fvEls.forEach( e => {
      e.classList.add('is-appeared');
    });
  });


  /* --- ハンバーガーメニュー --- */
  const navBtn = document.querySelector('.js-sG-navBtn');
  const txt = document.querySelector('.js-sG-navBtn > span');
  const nav = document.querySelector('.js-sG-nav');
  const trap = document.querySelector('.js-sG-trap');
  const navLinks = document.querySelectorAll('.js-sG-nav a');
  const body = document.body;

  navBtn.addEventListener('click', () => {
    navBtn.classList.toggle('is-open');
    const isOpen = nav.classList.toggle('is-open');
    body.classList.toggle('is-open');

    if (isOpen) {
      navBtn.setAttribute('aria-expanded', 'true');
      txt.textContent = 'メニューを閉じる';
    } else {
      navBtn.setAttribute('aria-expanded', 'false');
      txt.textContent = 'メニューを開く';
    }
  });

  // フォーカストラップ
  trap.addEventListener('focus', () => {
    navBtn.focus();
  });

  // 閉じる
  const close = () => {
    if (!navBtn.classList.contains('is-open')) return;

    body.classList.remove('is-open');
    navBtn.classList.remove('is-open');
    navBtn.setAttribute('aria-expanded', 'false');
    txt.textContent = 'メニューを閉じる';
    nav.classList.remove('is-open');
  }

  // Escキーでメニュー閉じる
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && nav.classList.contains('is-open')) {
      e.preventDefault();
      close();
      navBtn.focus();
    }
  });

  // ページ内リンクで閉じる
  navLinks.forEach(link => {
    link.addEventListener('click', () => {
      if (nav.classList.contains('is-open')) {
        close();
      }
    });
  });


  /* --- スクロール制御 --- */
  const header = document.querySelector('.js-sG-header');
  const fv = document.querySelector('.js-sG-fv');
  const fvHeight = fv.offsetHeight;

  let lastScrollY = window.scrollY;
  let isFixed = false;

  window.addEventListener("scroll", () => {
    // --- ヘッダー表示切り替え ---
    const currentScrollY = window.scrollY;
    const isScrollingUp = currentScrollY < lastScrollY;

    if (Math.abs(currentScrollY - lastScrollY) < 10) return;

    // FV内
    if (currentScrollY <= fvHeight) {
      header.classList.remove("is-fixed", "is-show");
      isFixed = false;
    } else {
      // FVを超えたとき
      if (!isFixed) {
        header.classList.add("is-fixed");
        isFixed = true;
      }

      // 上スクロール表示
      if (isScrollingUp) {
        header.classList.add("is-show");
      } else {
        // 下スクロール非表示
        header.classList.remove("is-show");
      }
    }

    lastScrollY = currentScrollY;


    // --- アニメーション ---
    const wHeight = window.innerHeight;
    const targets = document.querySelectorAll('.js-sG-target');

    targets.forEach( target => {
      const tPos = target.getBoundingClientRect().top + currentScrollY;

      if (currentScrollY > tPos - wHeight * 0.8) {
        target.classList.add('is-appeared');
      }
    });
  });


  /* --- アコーディオン --- */
  const ingredient = document.querySelector(".js-sG-ingredient");
  const btn = document.querySelector(".js-sG-ingredientBtn");

  btn.addEventListener('click', () => {
    const isOpen = ingredient.classList.toggle('is-open');

    if (isOpen) {
      btn.setAttribute('aria-expanded', 'true');
    } else {
      btn.setAttribute('aria-expanded', 'false');
    }
  });
}